import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';
import logoImg from '../../images/logo/infiniy-logo.png';
import { headerNav } from '../../content/navigation';
import { useContactModal } from './ContactModalContext';

const ArrowIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 12h14M12 5l7 7-7 7" />
  </svg>
);

const GlobeIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <line x1="2" y1="12" x2="22" y2="12" />
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
  </svg>
);

const ChevronDown = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M6 9l6 6 6-6" />
  </svg>
);

const Header = ({
  logoText,
  navItems,
  showLogoIcon = true,
  ctaText = 'Join Community',
  ctaPath = '/',
  showLanguage = true,
  languageLabel = 'EN',
}) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null); // 'Tracks' | 'Courses' | null
  const location = useLocation();
  const { openContactModal } = useContactModal();
  const items = navItems || headerNav;
  const isHomePage = location.pathname === '/';

  const closeMenu = () => {
    setMenuOpen(false);
    setOpenDropdown(null);
  };

  const isActive = (path) => location.pathname === path;

  return (
    <header className="common-header">
      {isHomePage && <div className="common-header-grid" aria-hidden="true" />}
      <div className="common-header-container">
        <div className="common-header-left">
          <Link to="/" className="common-header-logo-pill">
            {showLogoIcon && (
              <img src={logoImg} alt="" className="common-header-logo-img" loading="lazy" />
            )}
          </Link>
          <button
            type="button"
            className="common-header-menu-btn"
            aria-label="Toggle menu"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <span />
            <span />
            <span />
          </button>
        </div>
        <nav className={`common-header-nav ${menuOpen ? 'common-header-nav-open' : ''}`}>
          <ul className="common-header-nav-list">
            {items.map((item, i) => {
              const isDropdownOpen = item.dropdown && openDropdown === item.label;
              return (
              <li key={i} className={item.dropdown ? 'common-header-nav-item-has-dropdown' : ''}>
                {item.dropdown ? (
                  <>
                    <button
                      type="button"
                      className="common-header-nav-trigger"
                      onMouseEnter={() => !menuOpen && setOpenDropdown(item.label)}
                      onMouseLeave={() => setOpenDropdown(null)}
                      onClick={() => setOpenDropdown(isDropdownOpen ? null : item.label)}
                      aria-expanded={isDropdownOpen}
                      aria-haspopup="true"
                    >
                      {item.label}
                      <span className="common-header-nav-chevron"><ChevronDown /></span>
                    </button>
                    <ul
                      className={`common-header-dropdown ${isDropdownOpen ? 'common-header-dropdown-open' : ''}`}
                      onMouseEnter={() => setOpenDropdown(item.label)}
                      onMouseLeave={() => setOpenDropdown(null)}
                    >
                      {item.dropdown.map((sub, j) => (
                        <li key={j}>
                          <Link
                            to={sub.path}
                            className={isActive(sub.path) ? 'active' : ''}
                            onClick={closeMenu}
                          >
                            {sub.label}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </>
                ) : (
                  <>
                    {item.path.startsWith('/') && !item.path.includes('#') ? (
                      <Link
                        to={item.path}
                        className={isActive(item.path) ? 'active' : ''}
                        onClick={closeMenu}
                      >
                        {item.label}
                      </Link>
                    ) : (
                      <a href={item.path} onClick={closeMenu}>
                        {item.label}
                      </a>
                    )}
                  </>
                )}
              </li>
            );
            })}
          </ul>
        </nav>
        <div className="common-header-actions">
          {/* {showLanguage && (
            <button type="button" className="common-header-lang" aria-label="Language">
              <GlobeIcon />
              <span>{languageLabel}</span>
            </button>
          )} */}
          <button
            type="button"
            className="common-header-cta-pill"
            onClick={() => {
              closeMenu();
              openContactModal();
            }}
          >
            <span>{ctaText}</span>
            <span className="common-header-cta-arrow"><ArrowIcon /></span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
